import { Model } from "pinia-orm";
import Batch from "@/models/Batch";
import Question from "@/models/Question";

export default class QuestionBatch extends Model {
  static entity = "questionBatches";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      order: this.number(null),
      batchUuid: this.string(""),
      questionUuid: this.string(""),
      batchData: this.belongsTo(Batch, "batchUuid", "uuid"),
      questionData: this.belongsTo(Question, "questionUuid"),
    };
  }
}
